import ALL_SAUNAS_DATA from "../../data/saunas-data.json";
import ALL_CHAIRS_DATA from "../../data/chairs-data.json";
import { LoaderFunction } from "react-router-dom";

export declare type SwitchableType = "saunas" | "chairs";

export interface P3dModel {
  id: string;
  name: string;
  thumbnail: string;
}

export interface SwitchableData {
  id: string;
  name: string;
  models: P3dModel[];
  collection: string;
  type: string;
}

export interface SwitchableCollection {
  id: string;
  name: string;
}

export interface AllSwitchablesData {
  experiences: SwitchableData[];
  collections: SwitchableCollection[];
}

export const filterListingBySearch = (
  chairs: SwitchableData[],
  search: string,
): SwitchableData[] => {
  if (search) {
    const searchable = new RegExp(`${search}`, "i");
    return chairs.filter((e: SwitchableData): boolean =>
      searchable.test(e.name),
    );
  }
  return chairs;
};

ALL_CHAIRS_DATA.experiences.unshift({
  id: "massage-chairs-switcher",
  name: "Massage Chairs Picker",
  models: ALL_CHAIRS_DATA.experiences.reduce(
    (result: P3dModel[], { models }: SwitchableData): P3dModel[] => {
      result = result.concat(...models);
      return result;
    },
    [] as P3dModel[],
  ),
  collection: "chairs-main",
  type: "switcher",
});

ALL_SAUNAS_DATA.experiences.unshift({
  id: "saunas-switcher",
  name: "Saunas Picker",
  models: ALL_SAUNAS_DATA.experiences.reduce(
    (result: P3dModel[], { models }: SwitchableData): P3dModel[] => {
      result = result.concat(...models);
      return result;
    },
    [] as P3dModel[],
  ),
  collection: "chairs-main",
  type: "switcher",
});

export const loader_getAllSwitchables = (
  dataType: SwitchableType,
): LoaderFunction => {
  return (): AllSwitchablesData => {
    if ("saunas" === dataType) {
      return ALL_SAUNAS_DATA as AllSwitchablesData;
    } else if ("chairs" === dataType) {
      return ALL_CHAIRS_DATA as AllSwitchablesData;
    }
    throw new Error("Error when retrieving data, unsupported data type.");
  };
};

export const getSingleSwitchable = (
  dataType: SwitchableType,
  experienceID: string | undefined,
): SwitchableData | undefined => {
  if (!experienceID) {
    return undefined;
  }
  if ("chairs" === dataType) {
    return ALL_CHAIRS_DATA.experiences.find(
      ({ id }: SwitchableData): boolean => id === experienceID,
    );
  } else if ("saunas" === dataType) {
    return ALL_SAUNAS_DATA.experiences.find(
      ({ id }: SwitchableData): boolean => id === experienceID,
    );
  }
};
